<template>
  <el-dialog
    :title="$t('addMenuGroupCatalog.addCatalogGroup')"
    :visible.sync="dialogVisible"
    width="50%"
    @close="closeDialog">
    <el-form :model="addMenuGroupCatalogInfo" label-width="120px">
      <el-form-item :label="$t('addMenuGroupCatalog.menuGroup')" required>
        <el-select 
          v-model="addMenuGroupCatalogInfo.gId" 
          style="width:100%"
          :placeholder="$t('addMenuGroupCatalog.requiredSelect')">
          <el-option
            v-for="item in addMenuGroupCatalogInfo.menuGroups"
            :key="item.gId"
            :label="item.name"
            :value="item.gId">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">{{$t('common.cancel')}}</el-button>
      <el-button type="primary" @click="saveMenuGroupCatalogInfo">{{$t('common.save')}}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { saveMenuGroupCatalog, listMenuGroups } from '@/api/dev/menuGroupCatalogApi'

export default {
  name: 'AddMenuGroupCatalog',
  data() {
    return {
      dialogVisible: false,
      addMenuGroupCatalogInfo: {
        gcId: '',
        gId: '',
        caId: '',
        storeType: '',
        menuGroups: []
      }
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
      this._listMenuGroups()
    },
    closeDialog() {
      this.dialogVisible = false
      this.clearAddMenuGroupCatalogInfo()
    },
    async _listMenuGroups() {
      try {
        const params = {
          page: 1,
          row: 200,
          storeType: this.addMenuGroupCatalogInfo.storeType
        }
        const res = await listMenuGroups(params)
        this.addMenuGroupCatalogInfo.menuGroups = res.data
      } catch (error) {
        console.error('获取菜单组列表失败:', error)
      }
    },
    async saveMenuGroupCatalogInfo() {
      if (!this.validateForm()) {
        return
      }

      try {
        const res = await saveMenuGroupCatalog(this.addMenuGroupCatalogInfo)
        if (res.code === 0) {
          this.$message.success('添加成功')
          this.closeDialog()
          this.$emit('refresh')
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        console.error('保存菜单组目录失败:', error)
      }
    },
    validateForm() {
      if (!this.addMenuGroupCatalogInfo.gId) {
        this.$message.error('请选择菜单组')
        return false
      }
      return true
    },
    clearAddMenuGroupCatalogInfo() {
      const menuGroups = this.addMenuGroupCatalogInfo.menuGroups
      this.addMenuGroupCatalogInfo = {
        gcId: '',
        gId: '',
        storeType: '',
        menuGroups: menuGroups
      }
      console.log(this.addMenuGroupCatalogInfo.caId)
    }
  }
}
</script>